interface WorkTableBodyProps {
    children: React.ReactNode
}

export const WorkTableBody = ({ children }: WorkTableBodyProps) => {
    return <tbody>{children}</tbody>
}